(function() {
    'use strict';

    angular
        .module('elogbooks.user.escalations')
        .controller('EscalationsController', EscalationsController);

    EscalationsController.$inject = ['$state', '$stateParams', 'escalationCollectionResponse', 'user', 'rootResourceResponse', 'modulesService'];

    function EscalationsController($state, $stateParams, escalationCollectionResponse, user, rootResourceResponse, modulesService) {
        var vm = this;

        vm.escalationCollectionResponse = escalationCollectionResponse;
        vm.user = user;
        vm.quotesModuleEnabled = modulesService.isEnabled('quotes');
        vm.order = orderAction;
        vm.search = searchAction;
        vm.stateParams = $stateParams;

        // Initialize escalation stage dropdown options
        const escalationStageOptions = {
            openLink: rootResourceResponse.getLink('escalationstages'),
            itemValuePath: 'id',
            itemTitlePath: 'name',
            searchKey: 'name',
            responseKeyPath: 'escalationStages',
            loadOnOpen: true,
            loadmoreEnabled: true,
        };

        vm.criteria = {
            escalationStage: {
                type: 'jsonselectwidget',
                title: 'STAGE',
                value: JSON.parse($stateParams.escalationStage),
                options: escalationStageOptions
            },
            serviceProviderName: {type: 'text', title: 'SERVICE_PROVIDER', value: $stateParams.serviceProviderName}
        };

        function orderAction(key) {
            $stateParams.order = key;

            $state.go('.', angular.extend({}, $stateParams), { reload: $state.current });
        }

        function searchAction(params) {
            var override = {
                page: 1
            };

            $state.go('.', angular.extend({}, params, override), { reload: $state.current });
        }
    }
})();
